export class UnableToGetAppointmentTypeError extends Error {
	constructor(appointmentTypeId?: number) {
		let message = "Unable to get appointment type list.";
		if (appointmentTypeId)
			message =
				"Unable to get appointment type with id: " + appointmentTypeId;
		super(message);
		Object.setPrototypeOf(this, new.target.prototype);
	}
}
